var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcSpiltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.847,
    height: 115.586,
    viewBox: "0 0 198.847 115.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ac_Spilt-icon",
    "data-name": "Ac Spilt-icon",
    transform: "translate(-4349 3121.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M4547.847-3110.893v54.594a2.217,2.217,0,0,0-.37.522c-2.135,6.446-6.262,9.509-13.011,9.568-4.438.039-8.878-.041-13.315.036-1.42.025-2.07-.309-2.327-1.852q-1.017-6.117-2.421-12.167c-1.257-5.374-4.143-7.566-9.595-7.566H4390.741c-6.453,0-9.388,2.436-10.639,8.818-.725,3.7-1.507,7.384-2.164,11.092-.2,1.13-.534,1.686-1.8,1.669-4.956-.066-9.914.039-14.868-.077a11.746,11.746,0,0,1-9.836-5.15A36.473,36.473,0,0,1,4349-3056.3v-54.594c3.1-7.8,6.339-10.284,13.59-10.285q85.832-.012,171.664.011a17.911,17.911,0,0,1,4.17.39C4543.65-3119.511,4546.394-3115.8,4547.847-3110.893Zm-169.978,7.473c-2.141,0-4.283-.044-6.422.011-2.327.06-3.774,1.408-3.81,3.43a3.5,3.5,0,0,0,3.667,3.618q6.531.128,13.065-.005a3.47,3.47,0,0,0,3.575-3.692c-.091-2-1.431-3.277-3.652-3.344C4382.152-3103.465,4380.01-3103.415,4377.869-3103.419Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M4429.788-2970.58c.873-4.335,1.7-8.448,2.529-12.561.319-1.583,1.405-1.769,2.814-1.766q25.732.053,51.465.023c21.518,0,43.035.036,64.553-.052,2.271-.009,3.166.8,3.518,2.9.63,3.773,1.431,7.517,2.2,11.452Z",
    transform: "translate(-44.93 -75.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M4657.833-2926.384c-.106-3.1.971-4.52,3.065-4.717,2.158-.2,3.636.881,3.905,3.289a68.374,68.374,0,0,0,5.608,21.093,3.253,3.253,0,0,1-1.916,4.521c-1.892.806-3.544.2-4.571-1.858a64.431,64.431,0,0,1-5.564-18.368C4658.1-2923.953,4657.949-2925.5,4657.833-2926.384Z",
    transform: "translate(-171.752 -105.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M4472.024-2925.862a68.322,68.322,0,0,1-5.8,21.267c-1.126,2.384-3.045,3.242-4.959,2.312-1.954-.949-2.553-2.962-1.481-5.276a61.287,61.287,0,0,0,5.191-19.6c.188-1.8.751-3.359,2.664-3.945C4470.276-2931.912,4472.252-2929.946,4472.024-2925.862Z",
    transform: "translate(-61.319 -105.612)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M4521.5-2921.113c-.6,7.719-2.971,14.687-5.7,21.541a3.215,3.215,0,0,1-4.446,1.7,3.4,3.4,0,0,1-2.01-4.335c1.434-4.866,2.994-9.7,4.293-14.6a27.135,27.135,0,0,0,.6-5.909c.087-2.375,1.146-3.928,3.084-4.163s3.351.991,3.858,3.418C4521.366-2922.6,4521.426-2921.718,4521.5-2921.113Z",
    transform: "translate(-89.077 -108.043)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M4615.788-2921.5c1.413,5.318,2.8,10.642,4.255,15.948.369,1.346,1.026,2.613,1.4,3.958a3.182,3.182,0,0,1-2.094,4.095c-1.791.725-3.575.344-4.331-1.491-3.067-7.454-5.61-15.068-5.653-23.261-.008-1.592.332-3.329,2.085-3.776a4.67,4.67,0,0,1,3.648.448c.955.807,1.211,2.44,1.77,3.715Z",
    transform: "translate(-144.799 -108.442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M4572.459-2912.246c0,3.47.028,6.94-.009,10.409-.029,2.719-1.277,4.2-3.454,4.235-2.2.037-3.6-1.445-3.617-4.1q-.07-10.52,0-21.041c.017-2.576,1.5-4.2,3.594-4.172s3.447,1.617,3.477,4.258C4572.489-2919.186,4572.459-2915.716,4572.459-2912.246Z",
    transform: "translate(-120.319 -108.041)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcSpiltIcon);
export default __webpack_public_path__ + "static/media/Ac Spilt-icon.810bc1990fc6570c5bf0a447d5d57898.svg";
export { ForwardRef as ReactComponent };